import React from 'react';
import { FileItemLayout } from '../ui';
import FileItem from './FileItem';

const { FileListWrapper } = FileItemLayout;

const FileList = ({
  disabled,
  viewOnly,
  onlyUploadDisabled,
  files,
  onDeleteFile,
  iconOnlyButtons,
  activeFileId,
  requireDeleteConfirmation
}) => {
  const sortedFiles = [...files].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  return (
    <FileListWrapper>
      {sortedFiles.map((file) => (
        <FileItem
          disabled={disabled}
          viewOnly={viewOnly}
          onlyUploadDisabled={onlyUploadDisabled}
          key={file.id}
          file={file}
          onDelete={onDeleteFile}
          iconOnlyButtons={iconOnlyButtons}
          isActive={activeFileId === file.id}
          requireDeleteConfirmation={requireDeleteConfirmation}
        />
      ))}
    </FileListWrapper>
  );
};

export default FileList;
